// extracted by mini-css-extract-plugin
export var formContainer = "_kk-0";
export var message = "_kk-1";